import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { isDateExpired, RecourseCriteriaStore } from './recourse-criteria.store';

enum Icon {
  DisplayOnly = 'search',
  Edit = 'mode_edit',
}

@Component({
  templateUrl: './button-cell-renderer.component.html',
  styleUrls: ['./button-cell-renderer.component.scss'],
  imports: [PasButtonRoundComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  private readonly recrourseCriteriaStore = inject(RecourseCriteriaStore);

  private params: ICellRendererParams;

  public icon = '';

  public readonly dark = PasButtonRoundColor.DARK;

  public agInit(params: ICellRendererParams<any, any, any>): void {
    const determineIconByExpirationDate = (): string => {
      const isCriteriaAlreadyExpired = isDateExpired(this.params.data.validTo);
      return isCriteriaAlreadyExpired ? Icon.DisplayOnly : Icon.Edit;
    };

    this.params = params;
    this.icon = determineIconByExpirationDate();
  }

  public refresh(): boolean {
    return true;
  }

  public onEditClick(): void {
    this.recrourseCriteriaStore.editRecourseCriteria(this.params.data.id);
  }
}
